import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Product from "@/services/product";

export interface EditProductPayload {
  id: string;
  name: string;
  price: number;
  quantity: number;
  tax?: number;
  purchaseType: string;
  opportunityId?: string;
}

export function useEditProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditProductPayload) => {
      const result = await Product.editProduct(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to update product");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}
